import pCardIcon from 'assets/Icons/analytics-purchasing-card.svg'
import arIcon from 'assets/Icons/analytics-accounts-receivable.svg'
import glIcon from 'assets/Icons/analytics-general-ledger.svg'
import apIcon from 'assets/Icons/analytics-accounts-payable.svg'
import hrIcon from 'assets/Icons/analytics-human-resources.svg'
import payrollIcon from 'assets/Icons/analytics-payroll.svg'
import purchasingIcon from 'assets/Icons/analytics-purchasing.svg'
import requisitionsIcon from 'assets/Icons/analytics-requisitions.svg'
import sodIcon from 'assets/Icons/analytics-segregation-of-duties.svg'
import teIcon from 'assets/Icons/analytics-travel-entertainment.svg'
import vendorIcon from 'assets/Icons/analytics-vendor.svg'
import budgetIcon from 'assets/Icons/analytics-slfrf.svg'
import workflowIcon from 'assets/Icons/workflow.svg'
import pendingWorkflowIcon from 'assets/Icons/pending-workflow.svg'
import budgetByPeriodIcon from 'assets/Icons/analytics-budget-by-period.svg'
import okGrantsIcon from 'assets/Icons/analytics-ok-grants.svg'
import ubAccountsIcon from 'assets/Icons/analytics-ub-accounts.svg'
import ubAdjustmentsIcon from 'assets/Icons/analytics-ub-adjustments.svg'
import ubBillingIcon from 'assets/Icons/analytics-ub-billing.svg'
import ubConsumptionIcon from 'assets/Icons/analytics-ub-consumption.svg'
import contractsIcon from 'assets/Icons/analytics-contracts.svg'

const icons = {
  AP: apIcon,
  APLI: apIcon,
  AR: arIcon,
  BG: budgetIcon,
  BOT: budgetByPeriodIcon,
  GL: glIcon,
  HR: hrIcon,
  PR: payrollIcon,
  PC: pCardIcon,
  PO: purchasingIcon,
  RQ: requisitionsIcon,
  PWF: pendingWorkflowIcon,
  SOD: sodIcon,
  TE: teIcon,
  Vendor: vendorIcon,
  VO: vendorIcon,
  WF: workflowIcon,
  OKGT: okGrantsIcon,
  UBAccounts: ubAccountsIcon,
  UBAdjustments: ubAdjustmentsIcon,
  UBBilling: ubBillingIcon,
  UBConsumption: ubConsumptionIcon,
  UBFixedUsage: ubConsumptionIcon,
  CT: contractsIcon,
  CH: pCardIcon
}

export const getIcon = (sectionAbbreviation) => {
  return icons[sectionAbbreviation]
}

